
export default {
  props: ["usuarios"],
  methods: {},
};
